import { sortBy } from 'lodash';
import { matchSorter, MatchSorterOptions } from 'match-sorter';

import { Option } from 'components/shared/ControlledFields/ControlledSelect';

const searchOnMultipleWords = <T>(
  data: T[],
  filterValue: string,
  options: MatchSorterOptions<T>,
  sortProp?: string
) => {
  if (!filterValue || !filterValue.length) {
    return data;
  }

  const terms = filterValue.split(' ');
  if (!terms) {
    return data;
  }

  const searchResults = terms.reduceRight(
    (results, term) => matchSorter(results, term, options),
    data
  );

  if (sortProp) {
    return sortBy(searchResults, sortProp);
  }

  return searchResults;
};

export const createFilterOptions =
  (baseSortProp: string, keys: string[], sortProp?: string) =>
  <T>(data: T[], { inputValue }: { inputValue: string }) =>
    searchOnMultipleWords(
      data,
      inputValue,
      {
        keys,
        baseSort: (a, b) =>
          a.item[baseSortProp].localeCompare(b.item[baseSortProp]),
        threshold: matchSorter.rankings.CONTAINS
      },
      sortProp
    );

export const sortBasedOnABC = (a: Option, b: Option) => {
  if (a.label < b.label) {
    return -1;
  }
  if (a.label > b.label) {
    return 1;
  }
  return 0;
};
